import { DOCUMENT } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { CONTACT_FORM } from './placeholder';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilService, FundraiserService, VariablesService, EventsService } from '../../../../shared/services';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls: ['./contact-dialog.component.scss']
})
export class ContactDialogComponent implements OnInit, OnDestroy {

  @Input() public title;
  @Input() public id;
  info = CONTACT_FORM;
  contacForm: FormGroup;
  name: FormControl;
  email: FormControl;
  message: FormControl;
  captcha: FormControl;
  isWL: boolean;
  userdataSubs: Subscription;
  isloading;

  constructor(
    public utilService: UtilService,
    public fundraiserService: FundraiserService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public variablesService: VariablesService,
    private events: EventsService,
    public bottomSheet: MatBottomSheet,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.initForm();
    this.userdataSubs = this.variablesService.userData.subscribe({
      next: res => {
        if (res) {
          // this.contacForm.patchValue({
          //   name: res.full_name,
          //   email: res.email
          // });
        }
      }
    });
  }

  onCloseBtnClick(sendEvent: boolean, isCloseOrSend: string): void {
    if (sendEvent) {
      this.sendSystemEvents(isCloseOrSend);
    }
    this.dialog.closeAll();
    this.bottomSheet.dismiss();
    this.contacForm.reset();
  }

  initForm() {
    this.contacForm = new FormGroup({
      name: this.name = new FormControl('', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]),
      email: this.email = new FormControl('', [
        Validators.required, Validators.pattern(this.variablesService.email_Pattern_Regex)
      ]),
      message: this.message = new FormControl('', [Validators.required, Validators.minLength(10)]),
      captcha: this.captcha = new FormControl('', [Validators.required]),
    });
  }
  /**Submit conract form */
  submit() {
    if (this.contacForm.valid) {
      const payload = {
        'messageSenderName': this.name.value,
        'messageSenderEmail': this.email.value,
        'messageContent': this.message.value,
        'campaign_id': this.data.id,
        'type': this.data.contact || 'campaigner'
      };
      if (!this.isWL) {
        payload['g-recaptcha-response'] = this.captcha.value;
      }
      this.isloading = true;
      this.fundraiserService.contactCampaigner(payload).subscribe((res) => {

        const message = this.variablesService.isFundraiserLeftDialog ? 'Thank you for your wishes. We will share it with campaigner.' : 'Thank you for your query. We’ll get back to you shortly!';
        this.utilService.openSnackBar(message, 'success');
        this.contacForm.reset();
        this.dialog.closeAll();

        this.events.sendSystemEvent({
          eventName: 'contact_beneficiary',
          event_type: 'campaign',
          page_name: this.variablesService.pageName,
          event_type_id: this.variablesService.fundraiser.id,
          info_1: 'message sent'
        }).subscribe(_ => _);

        if (this.variablesService.isFundraiserLeftDialog) {
          this.events.sendSystemEvent({
            eventName: 'non_converted_user',
            event_type: 'campaign',
            page_name: 'campaign',
            info_1: 'leads_generated',
            info_2: ''
          });
        }
        this.onCloseBtnClick(true, 'leads');
        this.isloading = false;
      }, () => this.isloading = false);
    } else {
      this.utilService.checkValidForm(this.contacForm);
    }
  }

  sendSystemEvents(isCloseOrSend: string): void {
    const choices = {
      close: this.utilService.isMobile() ? 'popup_mobile_closed' : 'popup_desktop_closed',
      leads: 'leads_generated'
    };
    const eventPayload = {
      eventName: 'non_converted_user',
      event_type: 'campaign',
      page_name: 'campaign',
      info_1: choices[isCloseOrSend],
      info_2: ''
    };
    this.events.sendSystemEvent(eventPayload).subscribe(_ => _);
  }
  /**Error messages */
  getErrorMessage(control: FormControl) {
    switch (true) {
      case control.hasError('required'):
        return 'This field is required';
      case control.hasError('minlength'):
        return 'minimum 10 characters required';
    }
  }

  ngOnDestroy() {
    if (this.userdataSubs) { this.userdataSubs.unsubscribe(); }
  }

}
